const dutyquestion = {
    getlist: 'dutyquestion/getlist',
    add: 'dutyquestion/add',
    update: 'dutyquestion/update',
    remove: 'dutyquestion/remove',
    get: 'dutyquestion/get',
}
export default dutyquestion
